import React from "react"
import myInitObject from "../ultis/variable"
import TitleStyled from "./styles/titleStyles"
import FeedStyled from "./styles/FeedStyles"
import uuid from "react-uuid"
import FeedBox from "./feedBox"

const Feed = ({ heading, icon, iconPosition, column }) => {
  return (
    <FeedStyled icon={icon} iconPosition={iconPosition}>
      <section className="feed">
        <div className="container">
          <TitleStyled
            textAlign="center"
            linePosition="center"
            color="#000"
            lineColor="#000"
          >
            <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
          </TitleStyled>
        </div>
        <div className="feed__wrapper container container__feed blog__feed--2">
          {column.map(item => (
            <div key={uuid()} className="feed__item">
              <FeedBox
                img={myInitObject.cockpitUrl + item.value.icon.path}
                title={item.value.heading}
                descirption={item.value.description}
                link={item.value.link}
                linkText={item.value.linkText}
                linkPostion="bottom"
                titleSize="30"
              />
            </div>
          ))}
          <div className="feed__icon"></div>
        </div>
      </section>
    </FeedStyled>
  )
}

export default Feed
